import * as React from 'react';
import styled from 'styled-components';
import MuiListItemText, { ListItemTextProps as MuiListItemTextProps } from '@material-ui/core/ListItemText';

const StyledListItemText = styled(MuiListItemText)``;

export type DSListItemTextProps = MuiListItemTextProps;
export const DSListItemText: React.FC<DSListItemTextProps> = props => <StyledListItemText {...props} />;
DSListItemText.displayName = 'DSListItemText';
